import React from 'react'

import { Gong } from '../../../../state/models/audio'
import { Localized } from '../../../../state/models/space'
import { graphql } from '../../../../services/graphql'

import {
  DeepPartial,
  useSynchronizeData,
} from '../../../../hooks/use-synchronize-data'

import { buildComponent } from '../../../../components/factory'

import * as UI from '@mantine/core'
import * as Elements from '../../../../components/elements'
import * as Semantics from '../../../../components/semantics'

const ShowUniqueIdentifier = buildComponent<{ slug?: string }>().withRender(
  ({ props }) => (
    <UI.Group>
      <UI.Text weight={700}>Identifiant unique</UI.Text>
      <UI.Kbd mb={-4} px={16}>
        {props.slug ?? '...'}
      </UI.Kbd>
    </UI.Group>
  ),
)

const EditName = buildComponent<
  Partial<Gong> & {
    update: (next: DeepPartial<Gong>) => void
  }
>()
  .withLifecycle(({ props }) => ({
    update: (value: Localized) => props.update({ short: value }),
  }))
  .withRender(({ props, lifecycle }) => (
    <UI.Stack sx={{ width: '100%' }}>
      <UI.Input.Wrapper
        sx={{ flex: 1 }}
        label={<b style={{ fontSize: '2rem' }}>Nom du gong</b>}
        description="Nom affiché pour ce gong dans l'interface"
      >
        <Semantics.LocalizedInput
          value={props.short}
          onChange={lifecycle.update}
        />
      </UI.Input.Wrapper>
    </UI.Stack>
  ))

const EditIcon = buildComponent<
  Partial<Gong> & {
    update: (next: DeepPartial<Gong>) => void
  }
>().withRender(({ props }) => (
  <UI.Input.Wrapper
    style={{ width: '40rem' }}
    label={<b style={{ fontSize: '2rem' }}>Icône</b>}
    description="Icône carrée utilisée pour représenter ce gong. Format WEBP"
  >
    <Elements.ImageButton
      accept="webp"
      update={props.update}
      width={180}
      height={180}
      kind="gongs"
      variant="image"
      entity={props._id}
      slug={props.slug}
      image={props.image}
      fallback={props.slug}
    />
  </UI.Input.Wrapper>
))

export const SectionMain = buildComponent<{
  gong: string
}>()
  .withLifecycle(({ props }) => {
    return useSynchronizeData(
      graphql.queries.getGong,
      graphql.mutations.updateGong,
      props.gong,
    )
  })
  .withRender(({ lifecycle }) => (
    <UI.Group sx={{ flex: 1 }} spacing={64}>
      <UI.Stack spacing={24} sx={{ flex: 1, width: '100%' }}>
        <ShowUniqueIdentifier slug={lifecycle.data?.slug} />
        <EditName {...lifecycle.data} update={lifecycle.update} />
      </UI.Stack>

      <EditIcon {...lifecycle.data} update={lifecycle.update} />

      {lifecycle.loading && (
        <UI.Loader
          sx={{ position: 'absolute', top: '1rem', right: '1rem' }}
          size="xs"
        />
      )}
    </UI.Group>
  ))
